import { useEffect, useState } from "react";
// import {
//   hideLoader,
//   showLoader,
//   useLoader,
// } from "../../custom-hooks/loader/useLoader";
import { toast } from "react-toastify";
import Loader from "../Components/Loader";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft, FaCheck, FaTimes } from "react-icons/fa";
import { VscGitFetch } from "react-icons/vsc";
import TableSearch from "../Components/TableSearch";

const Devices = () => {
  const [loading, setLoading] = useState(false);
  const [devicesList, setDevicesList] = useState([]);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalDevices, setTotalDevices] = useState(0);
  
  const [selectedCopyRow, setSelectedCopyRow] = useState({});
  const [isCopy, setIsCopy] = useState(false); // const [isOpen, setIsOpen] = useState(false);

  const [searchType, setSearchType] = useState(null);
  const [search, setSearch] = useState("");
  const [registerFilter, setRegisterFilter] = useState("all");

  const options = [
    {
      id: 1,
      name: "IMEI No.",
      value: "imei",
    },
    {
      id: 2,
      name: "Serial No",
      value: "serialNumber",
    },
  ];

  const navigate = useNavigate();

  const getAllDevices = async (pageNumber = 1, filter = registerFilter) => {
  try {
    setLoading(true);

    let url = `http://spillas.com/api/v1/get-retailer-devices?page=${pageNumber}&per_page=20`;

    // ✅ Apply registration filter
    if (filter === "registered") {
      url += "&registered=true"; // optional query param (if backend supports)
    } else if (filter === "not_registered") {
      url += "&registered=false";
    }

    const response = await fetch(url);
    const data = await response.json();

    if (response.ok && data) {
      let devices = data?.data || [];

      // ✅ If API doesn’t support filter, handle on frontend
      if (filter === "registered") {
        devices = devices.filter((d) => d.customer_id !== null);
      } else if (filter === "not_registered") {
        devices = devices.filter((d) => d.customer_id === null);
      }

      setDevicesList(devices);
      setTotalPages(data?.last_page || 0);
      setTotalDevices(data?.total || 0);
      setPage(pageNumber);
    } else {
      toast.error(data?.message || "Something went wrong");
      setDevicesList([]);
    }
  } catch (error) {
    toast.error(error?.message || "Something went wrong");
  } finally {
    setLoading(false);
  }
};



  const handleSearchDevices = async () => {
  try {
    setLoading(true);
    const url = getSearchUrl();
    if (!url) return;

    const response = await fetch(url);
    const data = await response.json();
    if (response.ok && data) {
      setDevicesList(data?.data || []);
      setTotalPages(data?.last_page || 0);
    } else {
      toast.error(data?.message || "Something went wrong");
    }
  } catch (error) {
    toast.error(error?.message || "Something went wrong");
  } finally {
    setLoading(false);
  }
};


  const getSearchUrl = (date) => {
    if (!searchType || !search) return ""; // handle empty values
    switch (searchType) {
      case "imei":
        return `https://spillas.com/api/v1/get-retailer-devices?&imei=${search}`;

      case "serialNumber":
        return `https://spillas.com/api/v1/get-retailer-devices?&serialNumber=${search}`;

      default:
        return `https://spillas.com/api/v1/get-retailer-devices?&imei=${search}`; // fallback
    }
  };

  const convertDateInDDMMYY = (ISOdate) => {
    if (!ISOdate) return "-";
    let date = new Date(ISOdate);
    return `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()} ${
      date.getHours() + ":" + date.getMinutes()
    }`;
  };

  function extractFromGoex(path) {
    if (!path || typeof path !== "string") return "";
    const index = path.indexOf("goex");
    return index !== -1 ? path.slice(index) : "";
  }

  const copySelectedRow = async () => {
    if (!selectedCopyRow) return;
    setIsCopy(true);

    const textToCopy = JSON.stringify(selectedCopyRow, null, 2);

    try {
      await navigator.clipboard.writeText(textToCopy);
      alert("Text copied");
    } catch (err) {
      console.error("Failed to copy:", err);
      toast.error("Failed to copy text");
    } finally {
      setTimeout(() => {
        setIsCopy(false);
      }, 3000);
    }
  };

  useEffect(() => {
    getAllDevices(1);
  }, []);

  return (
    <div className="min-h-screen bg-white text-zinc-900">
      {/* Topbar */}
      <header className="sticky top-0 z-10 border-b border-zinc-200 bg-white/90 backdrop-blur">
        <div className="mx-auto px-5 py-4 flex items-center justify-between">
          <div>
            <h1 className="text-xl font-semibold tracking-tight">Devices</h1>
            <p className="text-xs text-zinc-500 mt-0.5">Directory of Devices</p>
          </div>
          <span className="hidden sm:inline-flex items-center rounded-full bg-blue-50 text-blue-700 ring-1 ring-inset ring-blue-200 px-2.5 py-1 text-xs font-medium">
            {totalDevices || 0} total
          </span>
        </div>
      </header>

      <main className="mx-auto px-8 py-6 space-y-4">
        {/* Filters */}
        <section className="rounded-2xl border border-zinc-200 bg-white p-3 sm:p-4">
          <div className="pt-3 pb-3">
            <button
              className="bg-blue-500 hover:bg-blue-400 cursor-pointer text-white px-2 py-1 rounded-md flex items-center gap-1"
              onClick={() => navigate(-1)}
            >
              <FaArrowLeft /> Go Back
            </button>
          </div>
          <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
            <div className="flex w-full flex-wrap items-center gap-2">
              {/* <div className="relative flex-1 min-w-[220px] md:w-[28rem]">
                <input
                  value={q}
                  onChange={(e) => setQ(e.target.value)}
                  placeholder="Search name / code / phone / email / location…"
                  className="w-full rounded-xl border border-zinc-200 bg-white px-3 py-2 pr-9 text-sm outline-none placeholder:text-zinc-400 focus:border-blue-300 focus:ring-2 focus:ring-blue-200"
                />
              </div>

              <button
                type="button"
                className="inline-flex items-center justify-center whitespace-nowrap rounded-xl bg-blue-600 px-3 py-2 text-sm font-medium text-white shadow-sm hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-200 cursor-pointer"
              >
                Search
              </button> */}
              <TableSearch
                options={options}
                handleSearch={handleSearchDevices}
                resetSearch={getAllDevices}
                search={search}
                setSearch={setSearch}
                searchType={searchType}
                setSearchType={setSearchType}
              ></TableSearch>


              <div className="flex items-center gap-2">
                <label className="text-sm text-gray-600 font-medium">Registration:</label>
                <select
                  value={registerFilter}
                  onChange={(e) => {
                    setRegisterFilter(e.target.value);
                    getAllDevices(1, e.target.value); // refetch when filter changes
                  }}
                  className="border border-gray-300 rounded-md px-2 py-1 text-sm focus:ring-blue-200 focus:ring-2 outline-none"
                >
                  <option value="all">All</option>
                  <option value="registered">Registered</option>
                  <option value="not_registered">Not Registered</option>
                </select>
              </div>
            </div>

            <div className="flex items-center gap-2">
              <button
                type="button"
                onClick={() => getAllDevices(1, registerFilter)}
                className="inline-flex items-center gap-2 rounded-xl bg-emerald-600 px-3 py-2 text-sm font-medium text-white shadow-sm hover:bg-emerald-500 focus:outline-none focus:ring-2 focus:ring-emerald-200 cursor-pointer"
              >
                <VscGitFetch size={18} />
                Fetch
              </button>

            </div>
          </div>
        </section>

        {/* Table */}
        <section className="rounded-2xl border border-zinc-200 bg-white shadow-sm overflow-hidden">
          <div className="w-full overflow-x-auto">
            <table className="w-full text-sm text-center">
              <thead className="sticky top-0 bg-blue-50 text-[12px] text-blue-800 uppercase tracking-wide">
                <tr className="border-y border-blue-100">
                  <Th>ID</Th>
                  <Th>Retailer ID</Th>
                  <Th>Enrollment Time</Th>
                  <Th>Register</Th>
                  <Th>Mapped</Th>
                  <Th>ImeI No</Th>
                  <Th>Serial No</Th>
                  <Th>Enterprise Name</Th>
                  <Th>Applied Policy</Th>
                  <Th>Policy Name</Th>
                  <Th>Brand</Th>
                  <Th>Mobile No.</Th>
                  <Th>Customer Status</Th>
                  <Th>Copy</Th>
                  {/* <Th>Apply Policy</Th> */}
                </tr>
              </thead>

              {loading ? (
                <tbody>
                  <tr>
                    <td colSpan={12}>
                      <div className="flex justify-center items-center w-full py-10">
                        <Loader />
                      </div>
                    </td>
                  </tr>
                </tbody>
              ) : (
                <tbody className="divide-y divide-zinc-100">
                  {devicesList?.length > 0 &&
                    devicesList.map((row, index) => (
                      <tr
                        key={row?.id || index}
                        className="hover:bg-zinc-50/70"
                      >
                        <Td center>{row?.id}</Td>
                        <Td className="font-medium text-left">
                          <div>
                            <p>{row?.retailer_id || "-"}</p>
                            <p>{row?.retailer_code || "-"}</p>
                          </div>
                        </Td>
                        <Td>{convertDateInDDMMYY(row?.enrollmentTime)}</Td>
                        <Td>
                          {row?.customer_id === null ? (
                            <FaTimes className="text-red-600 mx-auto" />
                          ) : (
                            <FaCheck className="text-green-600 mx-auto" />
                          )}
                        </Td>
                        <Td>
                          {row?.customer_id === null ? (
                            <FaTimes className="text-red-600 mx-auto" />
                          ) : (
                            <FaCheck className="text-green-600 mx-auto" />
                          )}
                        </Td>
                        <Td>{row?.imei || "-"}</Td>
                        <Td>{row?.serialNumber || "-"}</Td>

                        <Td className="hidden lg:table-cell text-left">
                          <div>
                            <p>{row?.enterprise?.split("/").pop() || "-"}</p>
                            <p className="text-xs text-zinc-500">{row?.name?.split("/").pop() || "-"}</p>
                          </div>
                        </Td>
                        <Td className="hidden md:table-cell">
                          {extractFromGoex(row?.appliedPolicyName) || "-"}
                        </Td>
                        <Td className="hidden md:table-cell">
                          {extractFromGoex(row?.policyName) || "-"}
                        </Td>
                        <Td>
                          <div>
                            <p>{row?.brand}</p>
                            <p className="text-xs text-zinc-500">
                              {row?.model}
                            </p>
                          </div>
                        </Td>
                        <Td>
                          <div className="flex flex-col">
                            <span>{row?.phoneNumber || "-"}</span>
                            <span>{row?.phoneNumber2 || "-"}</span>
                          </div>
                        </Td>
                        <Td>
                          {row?.is_deleted ? (
                            <span className="bg-red-500 text-white px-2 py-0.5 rounded text-xs">
                              Deleted
                            </span>
                          ) : (
                            <span className="bg-green-500 text-white px-2 py-0.5 rounded text-xs whitespace-nowrap">
                              Not Deleted
                            </span>
                          )}
                        </Td>
                        <Td>
                          <button
                            type="button"
                            className="bg-gray-400 text-white rounded-sm p-1 hover:bg-gray-300 cursor-pointer"
                            onClick={() => {
                              setSelectedCopyRow(row);
                              copySelectedRow();
                            }}
                          >
                            {isCopy && selectedCopyRow.id === row.id
                              ? "Copied"
                              : "Copy"}
                          </button>
                        </Td>
                        {/* <Td>
                          <button
                            type="button"
                            className={`${
                              row.customer_id === null
                                ? "bg-blue-400"
                                : "bg-blue-500 hover:bg-blue-400"
                            } text-white px-2 py-1 text-sm rounded-md whitespace-nowrap cursor-pointer`}
                            onClick={() => {
                              setIsOpen(true);
                              setSelectedDevice(row);
                            }}
                            disabled={row?.customer_id === null}
                          >
                            {row?.customer_id === null
                              ? "Mapped"
                              : "Apply Policy"}
                          </button>
                        </Td> */}
                      </tr>
                    ))}
                  {(!devicesList || devicesList.length === 0) && (
                    <tr>
                      <td
                        colSpan={12}
                        className="px-3 py-10 text-center text-sm text-zinc-400"
                      >
                        No results
                      </td>
                    </tr>
                  )}
                </tbody>
              )}
            </table>
          </div>

          {/* ✅ Simple Prev/Next Pagination */}
          {totalPages > 1 && (
            <div className="flex justify-end px-3 py-3">
              <nav className="flex items-center gap-1">
                {/* Prev Button */}
                <button
                  className="rounded-lg border border-zinc-200 px-2 py-1 text-sm disabled:opacity-50 hover:bg-blue-50"
                  onClick={() => {
                    if (page > 1) {
                      const newPage = page - 1;
                      setPage(newPage);
                      getAllDevices(newPage);
                    }
                  }}
                  disabled={page === 1}
                >
                  Prev
                </button>

                {/* Page Numbers with Dots */}
                {(() => {
                  const pageButtons = [];
                  const maxVisible = 5;
                  let startPage = Math.max(1, page - 2);
                  let endPage = Math.min(totalPages, startPage + maxVisible - 1);

                  if (endPage - startPage < maxVisible - 1) {
                    startPage = Math.max(1, endPage - maxVisible + 1);
                  }

                  // Always show first page if not included
                  if (startPage > 1) {
                    pageButtons.push(
                      <button
                        key={1}
                        className={`rounded-lg border px-2.5 py-1 text-sm ${
                          page === 1
                            ? "border-blue-600 bg-blue-600 text-white"
                            : "border-zinc-200 text-blue-700 hover:bg-blue-50"
                        }`}
                        onClick={() => {
                          setPage(1);
                          getAllDevices(1);
                        }}
                      >
                        1
                      </button>
                    );

                    if (startPage > 2) {
                      pageButtons.push(
                        <span key="start-ellipsis" className="px-1 text-gray-500">
                          ...
                        </span>
                      );
                    }
                  }

                  // Main visible range
                  for (let i = startPage; i <= endPage; i++) {
                    pageButtons.push(
                      <button
                        key={i}
                        className={`rounded-lg border px-2.5 py-1 text-sm ${
                          page === i
                            ? "border-blue-600 bg-blue-600 text-white"
                            : "border-zinc-200 text-blue-700 hover:bg-blue-50"
                        }`}
                        onClick={() => {
                          setPage(i);
                          getAllDevices(i);
                        }}
                      >
                        {i}
                      </button>
                    );
                  }

                  // Always show last page if not included
                  if (endPage < totalPages) {
                    if (endPage < totalPages - 1) {
                      pageButtons.push(
                        <span key="end-ellipsis" className="px-1 text-gray-500">
                          ...
                        </span>
                      );
                    }

                    pageButtons.push(
                      <button
                        key={totalPages}
                        className={`rounded-lg border px-2.5 py-1 text-sm ${
                          page === totalPages
                            ? "border-blue-600 bg-blue-600 text-white"
                            : "border-zinc-200 text-blue-700 hover:bg-blue-50"
                        }`}
                        onClick={() => {
                          setPage(totalPages);
                          getAllDevices(totalPages);
                        }}
                      >
                        {totalPages}
                      </button>
                    );
                  }

                  return pageButtons;
                })()}

                {/* Next Button */}
                <button
                  className="rounded-lg border border-zinc-200 px-2 py-1 text-sm disabled:opacity-50 hover:bg-blue-50"
                  onClick={() => {
                    if (page < totalPages) {
                      const newPage = page + 1;
                      setPage(newPage);
                      getAllDevices(newPage);
                    }
                  }}
                  disabled={page === totalPages}
                >
                  Next
                </button>
              </nav>
            </div>
          )}


        </section>
      </main>
    </div>
  );
};

export default Devices;

/* --- small UI atoms --- */
function Th({ children, className = "" }) {
  return (
    <th
      className={`px-3 sm:px-4 py-2 text-left whitespace-nowrap ${className}`}
    >
      {children}
    </th>
  );
}

function Td({ children, className = "", center = false }) {
  return (
    <td
      className={`px-3 sm:px-4 py-2 align-top ${
        center ? "text-center" : "text-left"
      } ${className}`}
    >
      {children}
    </td>
  );
}



// import { useEffect, useState } from "react";
// // import {
// //   hideLoader,
// //   showLoader,
// //   useLoader,
// // } from "../../custom-hooks/loader/useLoader";
// import { toast } from "react-toastify";
// import Loader from "../Components/Loader";
// import { useNavigate } from "react-router-dom";
// import { FaArrowLeft, FaCheck, FaTimes } from "react-icons/fa";
// import { VscGitFetch } from "react-icons/vsc";
// import TableSearch from "../Components/TableSearch";

// const Devices = () => {
//   const [loading, setLoading] = useState(false);
//   const [devicesList, setDevicesList] = useState([]);
//   const [page, setPage] = useState(0);
//   const [totalPages, setTotalPages] = useState(0);
//   const [totalDevices, setTotalDevices] = useState(0);
  
//   const [selectedCopyRow, setSelectedCopyRow] = useState({});
//   const [isCopy, setIsCopy] = useState(false); // const [isOpen, setIsOpen] = useState(false);

//   const [searchType, setSearchType] = useState(null);
//   const [search, setSearch] = useState("");

//   const options = [
//     {
//       id: 1,
//       name: "IMEI No.",
//       value: "imei",
//     },
//     {
//       id: 2,
//       name: "Serial No",
//       value: "serialNumber",
//     },
//   ];

//   const navigate = useNavigate();

//   const getAllDevices = async (pageNumber = 1) => {
//   try {
//     setLoading(true);
//     const response = await fetch(
//       `http://spillas.com/api/v1/get-retailer-devices?page=${pageNumber}&per_page=20`
//     );
//     const data = await response.json();
//     if (response.ok && data) {
//       setDevicesList(data?.data || []);
//       setTotalPages(data?.last_page || 0);
//       setTotalDevices(data?.total || 0);
//       setPage(pageNumber);
//     } else {
//       toast.error(data?.message || "Something went wrong");
//       setDevicesList([]);
//     }
//   } catch (error) {
//     toast.error(error?.message || "Something went wrong");
//   } finally {
//     setLoading(false);
//   }
// };


//   const handleSearchDevices = async () => {
//   try {
//     setLoading(true);
//     const url = getSearchUrl();
//     if (!url) return;

//     const response = await fetch(url);
//     const data = await response.json();
//     if (response.ok && data) {
//       setDevicesList(data?.data || []);
//       setTotalPages(data?.last_page || 0);
//     } else {
//       toast.error(data?.message || "Something went wrong");
//     }
//   } catch (error) {
//     toast.error(error?.message || "Something went wrong");
//   } finally {
//     setLoading(false);
//   }
// };


//   const getSearchUrl = (date) => {
//     if (!searchType || !search) return ""; // handle empty values
//     switch (searchType) {
//       case "imei":
//         return `https://spillas.com/api/v1/get-retailer-devices?&imei=${search}`;

//       case "serialNumber":
//         return `https://spillas.com/api/v1/get-retailer-devices?&serialNumber=${search}`;

//       default:
//         return `https://spillas.com/api/v1/get-retailer-devices?&imei=${search}`; // fallback
//     }
//   };

//   const convertDateInDDMMYY = (ISOdate) => {
//     if (!ISOdate) return "-";
//     let date = new Date(ISOdate);
//     return `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()} ${
//       date.getHours() + ":" + date.getMinutes()
//     }`;
//   };

//   function extractFromGoex(path) {
//     if (!path || typeof path !== "string") return "";
//     const index = path.indexOf("goex");
//     return index !== -1 ? path.slice(index) : "";
//   }

//   const copySelectedRow = async () => {
//     if (!selectedCopyRow) return;
//     setIsCopy(true);

//     const textToCopy = JSON.stringify(selectedCopyRow, null, 2);

//     try {
//       await navigator.clipboard.writeText(textToCopy);
//       alert("Text copied");
//     } catch (err) {
//       console.error("Failed to copy:", err);
//       toast.error("Failed to copy text");
//     } finally {
//       setTimeout(() => {
//         setIsCopy(false);
//       }, 3000);
//     }
//   };

//   useEffect(() => {
//     getAllDevices(1);
//   }, []);

//   return (
//     <div className="min-h-screen bg-white text-zinc-900">
//       {/* Topbar */}
//       <header className="sticky top-0 z-10 border-b border-zinc-200 bg-white/90 backdrop-blur">
//         <div className="mx-auto px-5 py-4 flex items-center justify-between">
//           <div>
//             <h1 className="text-xl font-semibold tracking-tight">Devices</h1>
//             <p className="text-xs text-zinc-500 mt-0.5">Directory of Devices</p>
//           </div>
//           <span className="hidden sm:inline-flex items-center rounded-full bg-blue-50 text-blue-700 ring-1 ring-inset ring-blue-200 px-2.5 py-1 text-xs font-medium">
//             {totalDevices || 0} total
//           </span>
//         </div>
//       </header>

//       <main className="mx-auto px-8 py-6 space-y-4">
//         {/* Filters */}
//         <section className="rounded-2xl border border-zinc-200 bg-white p-3 sm:p-4">
//           <div className="pt-3 pb-3">
//             <button
//               className="bg-blue-500 hover:bg-blue-400 cursor-pointer text-white px-2 py-1 rounded-md flex items-center gap-1"
//               onClick={() => navigate(-1)}
//             >
//               <FaArrowLeft /> Go Back
//             </button>
//           </div>
//           <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
//             <div className="flex w-full flex-wrap items-center gap-2">
//               {/* <div className="relative flex-1 min-w-[220px] md:w-[28rem]">
//                 <input
//                   value={q}
//                   onChange={(e) => setQ(e.target.value)}
//                   placeholder="Search name / code / phone / email / location…"
//                   className="w-full rounded-xl border border-zinc-200 bg-white px-3 py-2 pr-9 text-sm outline-none placeholder:text-zinc-400 focus:border-blue-300 focus:ring-2 focus:ring-blue-200"
//                 />
//               </div>

//               <button
//                 type="button"
//                 className="inline-flex items-center justify-center whitespace-nowrap rounded-xl bg-blue-600 px-3 py-2 text-sm font-medium text-white shadow-sm hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-200 cursor-pointer"
//               >
//                 Search
//               </button> */}
//               <TableSearch
//                 options={options}
//                 handleSearch={handleSearchDevices}
//                 resetSearch={getAllDevices}
//                 search={search}
//                 setSearch={setSearch}
//                 searchType={searchType}
//                 setSearchType={setSearchType}
//               ></TableSearch>
//             </div>

//             <div className="flex items-center gap-2">
//               <button
//                 type="button"
//                 onClick={() => getAllDevices()}
//                 className="inline-flex items-center gap-2 rounded-xl bg-emerald-600 px-3 py-2 text-sm font-medium text-white shadow-sm hover:bg-emerald-500 focus:outline-none focus:ring-2 focus:ring-emerald-200 cursor-pointer"
//               >
//                 <VscGitFetch size={18} />
//                 Fetch
//               </button>
//             </div>
//           </div>
//         </section>

//         {/* Table */}
//         <section className="rounded-2xl border border-zinc-200 bg-white shadow-sm overflow-hidden">
//           <div className="w-full overflow-x-auto">
//             <table className="w-full text-sm text-center">
//               <thead className="sticky top-0 bg-blue-50 text-[12px] text-blue-800 uppercase tracking-wide">
//                 <tr className="border-y border-blue-100">
//                   <Th>ID</Th>
//                   <Th>Retailer ID</Th>
//                   <Th>Enrollment Time</Th>
//                   <Th>Register</Th>
//                   <Th>Mapped</Th>
//                   <Th>ImeI No</Th>
//                   <Th>Serial No</Th>
//                   <Th>Enterprise Name</Th>
//                   <Th>Applied Policy</Th>
//                   <Th>Policy Name</Th>
//                   <Th>Brand</Th>
//                   <Th>Mobile No.</Th>
//                   <Th>Customer Status</Th>
//                   <Th>Copy</Th>
//                   {/* <Th>Apply Policy</Th> */}
//                 </tr>
//               </thead>

//               {loading ? (
//                 <tbody>
//                   <tr>
//                     <td colSpan={12}>
//                       <div className="flex justify-center items-center w-full py-10">
//                         <Loader />
//                       </div>
//                     </td>
//                   </tr>
//                 </tbody>
//               ) : (
//                 <tbody className="divide-y divide-zinc-100">
//                   {devicesList?.length > 0 &&
//                     devicesList.map((row, index) => (
//                       <tr
//                         key={row?.id || index}
//                         className="hover:bg-zinc-50/70"
//                       >
//                         <Td center>{row?.id}</Td>
//                         <Td className="font-medium text-left">
//                           <div>
//                             <p>{row?.retailer_id || "-"}</p>
//                             <p>{row?.retailer_code || "-"}</p>
//                           </div>
//                         </Td>
//                         <Td>{convertDateInDDMMYY(row?.enrollmentTime)}</Td>
//                         <Td>
//                           {row?.customer_id === null ? (
//                             <FaTimes className="text-red-600 mx-auto" />
//                           ) : (
//                             <FaCheck className="text-green-600 mx-auto" />
//                           )}
//                         </Td>
//                         <Td>
//                           {row?.customer_id === null ? (
//                             <FaTimes className="text-red-600 mx-auto" />
//                           ) : (
//                             <FaCheck className="text-green-600 mx-auto" />
//                           )}
//                         </Td>
//                         <Td>{row?.imei || "-"}</Td>
//                         <Td>{row?.serialNumber || "-"}</Td>

//                         <Td className="hidden lg:table-cell text-left">
//                           <div>
//                             <p>{row?.enterprise?.split("/").pop() || "-"}</p>
//                             <p className="text-xs text-zinc-500">{row?.name?.split("/").pop() || "-"}</p>
//                           </div>
//                         </Td>
//                         <Td className="hidden md:table-cell">
//                           {extractFromGoex(row?.appliedPolicyName) || "-"}
//                         </Td>
//                         <Td className="hidden md:table-cell">
//                           {extractFromGoex(row?.policyName) || "-"}
//                         </Td>
//                         <Td>
//                           <div>
//                             <p>{row?.brand}</p>
//                             <p className="text-xs text-zinc-500">
//                               {row?.model}
//                             </p>
//                           </div>
//                         </Td>
//                         <Td>
//                           <div className="flex flex-col">
//                             <span>{row?.phoneNumber || "-"}</span>
//                             <span>{row?.phoneNumber2 || "-"}</span>
//                           </div>
//                         </Td>
//                         <Td>
//                           {row?.is_deleted ? (
//                             <span className="bg-red-500 text-white px-2 py-0.5 rounded text-xs">
//                               Deleted
//                             </span>
//                           ) : (
//                             <span className="bg-green-500 text-white px-2 py-0.5 rounded text-xs whitespace-nowrap">
//                               Not Deleted
//                             </span>
//                           )}
//                         </Td>
//                         <Td>
//                           <button
//                             type="button"
//                             className="bg-gray-400 text-white rounded-sm p-1 hover:bg-gray-300 cursor-pointer"
//                             onClick={() => {
//                               setSelectedCopyRow(row);
//                               copySelectedRow();
//                             }}
//                           >
//                             {isCopy && selectedCopyRow.id === row.id
//                               ? "Copied"
//                               : "Copy"}
//                           </button>
//                         </Td>
//                         {/* <Td>
//                           <button
//                             type="button"
//                             className={`${
//                               row.customer_id === null
//                                 ? "bg-blue-400"
//                                 : "bg-blue-500 hover:bg-blue-400"
//                             } text-white px-2 py-1 text-sm rounded-md whitespace-nowrap cursor-pointer`}
//                             onClick={() => {
//                               setIsOpen(true);
//                               setSelectedDevice(row);
//                             }}
//                             disabled={row?.customer_id === null}
//                           >
//                             {row?.customer_id === null
//                               ? "Mapped"
//                               : "Apply Policy"}
//                           </button>
//                         </Td> */}
//                       </tr>
//                     ))}
//                   {(!devicesList || devicesList.length === 0) && (
//                     <tr>
//                       <td
//                         colSpan={12}
//                         className="px-3 py-10 text-center text-sm text-zinc-400"
//                       >
//                         No results
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               )}
//             </table>
//           </div>

//           {/* ✅ Simple Prev/Next Pagination */}
//           {totalPages > 1 && (
//             <div className="flex justify-end px-3 py-3">
//               <nav className="flex items-center gap-1">
//                 {/* Prev Button */}
//                 <button
//                   className="rounded-lg border border-zinc-200 px-2 py-1 text-sm disabled:opacity-50 hover:bg-blue-50"
//                   onClick={() => {
//                     if (page > 1) {
//                       const newPage = page - 1;
//                       setPage(newPage);
//                       getAllDevices(newPage);
//                     }
//                   }}
//                   disabled={page === 1}
//                 >
//                   Prev
//                 </button>

//                 {/* Page Numbers with Dots */}
//                 {(() => {
//                   const pageButtons = [];
//                   const maxVisible = 5;
//                   let startPage = Math.max(1, page - 2);
//                   let endPage = Math.min(totalPages, startPage + maxVisible - 1);

//                   if (endPage - startPage < maxVisible - 1) {
//                     startPage = Math.max(1, endPage - maxVisible + 1);
//                   }

//                   // Always show first page if not included
//                   if (startPage > 1) {
//                     pageButtons.push(
//                       <button
//                         key={1}
//                         className={`rounded-lg border px-2.5 py-1 text-sm ${
//                           page === 1
//                             ? "border-blue-600 bg-blue-600 text-white"
//                             : "border-zinc-200 text-blue-700 hover:bg-blue-50"
//                         }`}
//                         onClick={() => {
//                           setPage(1);
//                           getAllDevices(1);
//                         }}
//                       >
//                         1
//                       </button>
//                     );

//                     if (startPage > 2) {
//                       pageButtons.push(
//                         <span key="start-ellipsis" className="px-1 text-gray-500">
//                           ...
//                         </span>
//                       );
//                     }
//                   }

//                   // Main visible range
//                   for (let i = startPage; i <= endPage; i++) {
//                     pageButtons.push(
//                       <button
//                         key={i}
//                         className={`rounded-lg border px-2.5 py-1 text-sm ${
//                           page === i
//                             ? "border-blue-600 bg-blue-600 text-white"
//                             : "border-zinc-200 text-blue-700 hover:bg-blue-50"
//                         }`}
//                         onClick={() => {
//                           setPage(i);
//                           getAllDevices(i);
//                         }}
//                       >
//                         {i}
//                       </button>
//                     );
//                   }

//                   // Always show last page if not included
//                   if (endPage < totalPages) {
//                     if (endPage < totalPages - 1) {
//                       pageButtons.push(
//                         <span key="end-ellipsis" className="px-1 text-gray-500">
//                           ...
//                         </span>
//                       );
//                     }

//                     pageButtons.push(
//                       <button
//                         key={totalPages}
//                         className={`rounded-lg border px-2.5 py-1 text-sm ${
//                           page === totalPages
//                             ? "border-blue-600 bg-blue-600 text-white"
//                             : "border-zinc-200 text-blue-700 hover:bg-blue-50"
//                         }`}
//                         onClick={() => {
//                           setPage(totalPages);
//                           getAllDevices(totalPages);
//                         }}
//                       >
//                         {totalPages}
//                       </button>
//                     );
//                   }

//                   return pageButtons;
//                 })()}

//                 {/* Next Button */}
//                 <button
//                   className="rounded-lg border border-zinc-200 px-2 py-1 text-sm disabled:opacity-50 hover:bg-blue-50"
//                   onClick={() => {
//                     if (page < totalPages) {
//                       const newPage = page + 1;
//                       setPage(newPage);
//                       getAllDevices(newPage);
//                     }
//                   }}
//                   disabled={page === totalPages}
//                 >
//                   Next
//                 </button>
//               </nav>
//             </div>
//           )}


//         </section>
//       </main>
//     </div>
//   );
// };

// export default Devices;

// /* --- small UI atoms --- */
// function Th({ children, className = "" }) {
//   return (
//     <th
//       className={`px-3 sm:px-4 py-2 text-left whitespace-nowrap ${className}`}
//     >
//       {children}
//     </th>
//   );
// }

// function Td({ children, className = "", center = false }) {
//   return (
//     <td
//       className={`px-3 sm:px-4 py-2 align-top ${
//         center ? "text-center" : "text-left"
//       } ${className}`}
//     >
//       {children}
//     </td>
//   );
// }
